import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter, catchError } from 'rxjs/operators';
import { IJobsiteSalesAreasResponse, JobsiteSalesAreasService } from '@cemex-core/cmx-api';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickLoadJobsiteSalesAreaAction,
  OneClickJobsiteSalesAreaActionTypes,
  OneClickLoadJobsiteSalesAreaCompleteAction,
  OneClickPurchaseOrderValidation,
  OneClickErrorLoadJobsiteSalesAreaAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-jobsite-sales-area.actions';
import { SHIPMENT_LOCATION_TYPE_ID } from '@ordersnproducts/modules/shared/constants/shipment-location-type-id';
import { of } from 'rxjs';

@Injectable()
export class OneClickJobsiteSalesAreaFromOrderEffects {
  loadJobsiteSalesAreaCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadJobsiteSalesAreaAction(action.payload);
      }),
    ),
  );

  getJobsiteSalesArea = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA),
      map((action: OneClickLoadJobsiteSalesAreaAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.jobsiteSalesAreasService
          .getAddresses({
            shipmentLocationId: {
              entityId: order.jobsite.jobsiteId,
              entityTypeId: SHIPMENT_LOCATION_TYPE_ID.JOBSITE,
            },
            productLineId: order.items[0].product.productType.productTypeId,
          })
          .pipe(
            map((response: IJobsiteSalesAreasResponse) => {
              return new OneClickLoadJobsiteSalesAreaCompleteAction(response.jobsiteSalesAreas);
            }),
            catchError((error) => of(new OneClickErrorLoadJobsiteSalesAreaAction(error))),
          );
      }),
    ),
  );

  purchaseOrderValidation = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA_COMPLETE),
      map((payload: OneClickLoadJobsiteSalesAreaCompleteAction) => {
        return new OneClickPurchaseOrderValidation(payload.payload[0].purchaseOrderValidation);
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private jobsiteSalesAreasService: JobsiteSalesAreasService,
  ) {}
}
